export const blockIconsHouseholdOutdoorGrillNew = (
	<span className='material-symbols-outlined'>outdoor_grill</span>
);
